var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-full",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();}}},[_c('button',{staticClass:"btn btn-nav",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c(_setup.ArrowLeft,{staticClass:"w-5 h-5"}),_vm._v(" "+_vm._s(_vm.backText)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }